<template>
    <div class="row" v-if="totalPage > 1">
            <div class="col-md-12">
                  <ul class="pagination transaction-page justify-content-center">
                    <li class="page-item" @click="getData(1)">
                        <span class="page-link"> < </span>
                    </li>
                    <li class="page-item " :class="{ active: page === pageIndex }"  
                        v-for="page in totalPage" :key="page" @click="getData(page)"
                        v-if="Math.abs(page - pageIndex) < 3 || page == totalPage - 0 || pageIndex == 0">
                        <a class="page-link" 
                            :class="{current: pageIndex === page, last: (page == totalPage - 1 && Math.abs(page - pageIndex) > 3), first:(page == 0 && Math.abs(page - pageIndex) > 3)}">
                          {{page}}
                        </a>
                    </li>
                    <li class="page-item" @click="getData(totalPage)">
                        <span class="page-link"> > </span>
                    </li>
                  </ul>
            </div>
    </div>
</template>

<script>
    export default {
        props:['totalPage','pageIndex','selectTransactionType'],
        methods:{
            getData(sendData){
                this.$emit("fetchData",sendData,this.selectTransactionType);
            },
        },
    }
</script>

<style scoped>

</style>